// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__1uqjw","CardInfo":"Card_CardInfo__6vzaL"};